import { RecommendedBrand } from "components/UI/molecules";
import { useGetRecommendations } from "./utils/useGetRecommendations";
import "./index.scss";

export const Recommended = ({ legacyBrandId }) => {
  const { recommendations } = useGetRecommendations({ legacyBrandId });

  if (!recommendations) return null;

  return (
    <section className="recommended">
      <header className="header">
        <h2 className="title">Recommended For You</h2>
      </header>
      <ul className="main">
        {recommendations.map((item) => (
          <li key={item.uuid} className="item">
            <RecommendedBrand
              image={item.image_url}
              title={item.name}
              slug={item.legacy_slug}
            />
          </li>
        ))}
      </ul>
    </section>
  );
};
